import { render } from "./GlobalCommandSearch.vue?vue&type=template&id=a9c1c0ae"
import script from "./GlobalCommandSearch.vue?vue&type=script&lang=js"
export * from "./GlobalCommandSearch.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/felipe_admin_sr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__